import styled from 'styled-components/macro';
import { defaultContainer } from '../../../styles/utils';
import { BlueTextLink } from '../../../components/LinkStyles';

export const ReferralsDiv = styled.div`
  ${defaultContainer}
`;

export const ReferralsHeaderDiv = styled.div`
  padding-top: 3rem;
  /* margin-bottom: 3rem; */
  @media screen and (max-width: 767px) {
    margin-left: -2rem;
  }
`;

export const HeaderTotalH6 = styled.h6`
  font-size: 1.2rem;
  color: ${props => props.theme.blue};
  border-bottom: ${props => props.theme.defaultBorder};
  line-height: 1.8rem;
  padding: 0rem 0;
  text-align: right;
  display: flex;
  align-items: center;
  white-space: pre-wrap;
`;

export const ViewAllLink = styled(BlueTextLink)`
  font-size: 1.2rem;
  color: ${props => props.theme.blue};
  border-bottom: ${props => props.theme.defaultBorder};
  line-height: 1.8rem;
  padding: 0rem 0;
  text-align: right;
  display: flex;
  align-items: center;
  white-space: pre-wrap;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;
`;
